"use strict";
"use client";
import { useId, useRef, useContext, useCallback } from "react";
import { ModalContext } from "./ModalContext.js";
function createUseModal(component) {
  return () => {
    const id = useId();
    const modalRef = useRef(null);
    const context = useContext(ModalContext);
    const setModal = useCallback(
      (props) => {
        modalRef.current = props;
        context.setModal({ ...props, id, component, open: true });
      },
      [context, id]
    );
    const removeModal = useCallback(() => {
      if (modalRef.current) {
        context.removeModal({
          ...modalRef.current,
          id,
          component,
          open: false
        });
        modalRef.current = null;
      }
    }, [context, id]);
    return { setModal, removeModal };
  };
}
export {
  createUseModal
};
